module.exports = __webpack_public_path__ + "c6ea6231fd52eb269ff4ff02579dd67e.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/LabilGrotesk-Bold.woff2
// module id = 30
// module chunks = 0 1